export enum OpportunityTypeOption {
  NEW_CUSTOMER = '5a6b5112-ed0e-4431-8719-89a7bd1e4c65',
  VOLUME_DEVELOPMENT = 'd5ef3dcd-c3d9-4fe7-af63-76549351d677',
  NEW_OPPORTUNITY = 'f4bdd3f6-cbec-47ae-aaa1-18c0b4da7879',
}
